import { addDays, isAfter } from 'date-fns';
import { IPrice, IPeople, IDeadline } from '../../ShoppingCart/types';

export function insuranceMinDateTime(): Date {
  // 2022年7月保険商品の臨時対応。
  const today = new Date();
  const CurrentDate = new Date(today.getFullYear(), today.getMonth(), today.getDate(), 14, 0, 0);
  const minDate = new Date(2022, 8, 0, 14, 0, 0);
  return isAfter(CurrentDate, minDate) ? CurrentDate : minDate;
}

export function ticketMinDateTime(): Date {
  const today = new Date();
  return new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59);
}

export function ticketMaxDateTime(): Date {
  const today = new Date();
  const daysAfter = addDays(today, 99);
  return new Date(daysAfter.getFullYear(), daysAfter.getMonth(), daysAfter.getDate(), 23, 59, 59);
}

// CAUTION:
// 子供価格が0でも大人限定というフラグが立っていなければ0円として計算される
export function sumPrices(prices: IPrice[], people: IPeople): IPrice {
  return prices.reduce((prevPrice: IPrice, currentPrice: IPrice) => {
    return {
      adultPrice: prevPrice.adultPrice + (currentPrice.adultPrice || 0) * people.adultNum,
      childPrice: prevPrice.childPrice + (currentPrice.childPrice || 0) * people.childNum,
      groupPrice: prevPrice.groupPrice + (currentPrice.groupPrice || 0),
      studentPrice: prevPrice.studentPrice + (currentPrice.studentPrice || 0) * people.studentNum,
      seniorPrice: prevPrice.seniorPrice + (currentPrice.seniorPrice || 0) * people.seniorNum,
      adultFullPrice: prevPrice.adultFullPrice + (currentPrice.adultFullPrice || 0) * people.adultNum,
      childFullPrice: prevPrice.childFullPrice + (currentPrice.childFullPrice || 0) * people.childNum,
      groupFullPrice: prevPrice.groupFullPrice + (currentPrice.groupFullPrice || 0),
      studentFullPrice: prevPrice.studentFullPrice + (currentPrice.studentFullPrice || 0) * people.studentNum,
      seniorFullPrice: prevPrice.seniorFullPrice + (currentPrice.seniorFullPrice || 0) * people.seniorNum,
      // 保険情報を保持（最初の価格データから取得）
      insuranceApplicable: currentPrice.insuranceApplicable,
      maxParticipantsAtOnce: currentPrice.maxParticipantsAtOnce,
      forGroup: currentPrice.forGroup,
    }
  }, { adultPrice: 0, childPrice: 0, groupPrice: 0, studentPrice: 0, seniorPrice: 0, adultFullPrice: 0, childFullPrice: 0, groupFullPrice: 0, studentFullPrice: 0, seniorFullPrice: 0, insuranceApplicable: false, maxParticipantsAtOnce: 0, forGroup: false });
}
